import React from 'react';
import WarningTriangleIcon from '@shared/icons/WarningTriangleIcon';
import SchoolContactLine from '@/components/SchoolContactLine';

/**
 * Neutral landing for a Checkout session that did not collect anything:
 * the parent backed out (cancel URL), the session expired, or a success
 * URL was reached with a session Stripe says is unpaid. No charge was
 * made either way, and the copy says so before anything else.
 */
const PaymentNotCompletedScreen = ({ result, outcome }) => {
	const body =
		outcome === 'cancel'
			? 'No charge was made. You can return to the app to try again whenever you’re ready.'
			: 'This checkout session ended before the payment went through. No charge was made. Return to the app to try again.';

	return (
		<div className="flex flex-col items-center gap-[18px] pt-[12px] text-center">
			<div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-pay-warn-bg text-pay-ink">
				<WarningTriangleIcon width={32} height={32} aria-hidden="true" focusable="false" />
			</div>
			<h1 className="text-[24px] font-extrabold text-pay-ink">Payment not completed</h1>
			<p className="text-[14px] leading-[21px] text-pay-muted">{body}</p>
			<p className="text-[13px] text-pay-muted">You can close this window and return to the app.</p>
			<SchoolContactLine school={result?.school} />
		</div>
	);
};

export default PaymentNotCompletedScreen;
